import { logger as grLogger } from '@otto-ec/global-resources/debug';
import type { ScopedLogger } from './types/types';

export const log: ScopedLogger = grLogger('reptile.dundee');
export const navigationLog = log.scope('Navigation');
